window.onload = function() {
    const isCollection = window.location.pathname.includes("/search") || window.location.pathname.includes("/collections/");
    if(isCollection) {
      handleOpenCartPopup();
    }
    // fix from price
    document.addEventListener("bss_b2b_doneCheckCp", e => {
        $("[bss-b2b-product-from-price]:not(:contains(ab ))").addClass("from-suffix")
    });
    $(".search-input input").on("keydown", BSS_B2B.debounce(e => handleExecPriceCartSlider(), 1000))

    $(document).on("change", "input[name^='product-form'], input[name^='quick-buy-form']", e => {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0)
    })
    function handleExecPriceCartSlider() {
        BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0);
        setTimeout(() => {
            BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData, 0, 0)
        }, 500);
    }

  function handleOpenCartPopup(){
    const targetNodeAll = document.querySelectorAll('quick-buy-drawer');
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                console.log(123); BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,0,0)
            }
        }
    });
    const config = { attributes: true };
    if (targetNodeAll) {
        targetNodeAll.forEach((targetNode) => {
            observer.observe(targetNode, config);
        })
    }
  }
  $(".product-card__quick-buy button").on("click", () => {
    setTimeout(() => {
      BSS_B2B.cp.changeProductPrice(JSON.parse($('#bss-b2b-store-data').html()), false, false);
    }, 2000);
  })
}

window.addEventListener("cart_changed", () => {
  BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData);
  BSS_B2B.cart.fixer(
        JSON.parse($("#bss-b2b-store-data").html()),
        false,
        false
      );
});